import { motion } from "framer-motion";

const TONES = {
  dark: "text-[#2A1B3D] hover:text-[#4A2D6B] bg-[#FFF9F0]/[0.86] border-white/80",
  light: "text-[#F3E8FF]/90 hover:text-white bg-white/10 border-white/20",
  ink: "text-[#FFF4DC] hover:text-white bg-[#22152F]/[0.84] border-[#E9C987]/45",
};
const PILL = "group flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-1 font-hand text-[22px] leading-none shadow-[0_6px_18px_-8px_rgba(20,10,35,0.5)] backdrop-blur-md transition-colors duration-300 [touch-action:manipulation]";

// The way home, always in the same place: the step back (to the room, the windows...) and "Gallery" (the Feeling Wall).
export function ReturnControl({ onClick, label = "return", tone = "dark", testid = "return-control", pos = "top-[4.6rem]", onGallery }) {
  return (
    <motion.nav
      data-testid="home-nav"
      aria-label="Way home"
      initial={{ opacity: 0, x: -6 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.6, duration: 1.2 }}
      className={`brand-gap fixed left-4 ${pos} z-[90] flex max-w-[calc(100vw-2rem)] items-center gap-2 sm:left-6`}
      style={{ marginTop: "env(safe-area-inset-top, 0px)" }}
    >
      <button data-testid={testid} onClick={onClick} aria-label={`Go back: ${label}`} className={`${PILL} min-w-0 ${TONES[tone]}`}>
        <span className="inline-block transition-transform duration-300 group-hover:-translate-x-1">←</span>
        <span className="inline-block pr-[0.15em]">{label}</span>
      </button>
      {onGallery && (
        <button data-testid="nav-gallery-button" onClick={onGallery} aria-label="Go to the gallery: the Feeling Wall" className={`${PILL} ${TONES[tone]}`}>
          Gallery
        </button>
      )}
    </motion.nav>
  );
}
